export var TimestampFilterKind;
(function (TimestampFilterKind) {
    TimestampFilterKind["Between"] = "Between";
    TimestampFilterKind["After"] = "After";
    TimestampFilterKind["Before"] = "LesserThan";
})(TimestampFilterKind || (TimestampFilterKind = {}));
